// extracted by mini-css-extract-plugin
module.exports = {"footer":"Footer_footer__1w0lV","section":"Footer_section__jtYFE","text":"Footer_text__BdXqz","link":"Footer_link__Xabb2"};